import { useState } from 'react'
import { useAuth } from '@/context/AuthContext'
import { Link } from 'react-router-dom'

export function AutofillPrompt() {
  const { user, updateProfile } = useAuth()
  const [step, setStep] = useState<'prompt' | 'form'>('prompt')
  const [email, setEmail] = useState('')
  const [delivery_address, setDeliveryAddress] = useState('')
  const [saving, setSaving] = useState(false)

  if (!user || user.autofill_prompt_shown === false) return null

  const handleLater = async () => {
    setSaving(true)
    try {
      await updateProfile({ autofill_prompt_shown: false })
    } finally {
      setSaving(false)
    }
  }

  const handleFill = () => {
    setEmail(user.email ?? '')
    setDeliveryAddress(user.delivery_address ?? '')
    setStep('form')
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setSaving(true)
    try {
      await updateProfile({
        email: email.trim(),
        delivery_address: delivery_address.trim(),
        autofill_prompt_shown: false,
      })
    } finally {
      setSaving(false)
    }
  }

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
      role="dialog"
      aria-modal="true"
      aria-labelledby="autofill-title"
    >
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
        {step === 'prompt' ? (
          <>
            <div className="p-6">
              <h2 id="autofill-title" className="text-xl font-semibold text-gray-900 mb-2">
                Добавьте данные для заказа
              </h2>
              <p className="text-gray-600 text-sm">
                Укажите email и адрес доставки, чтобы быстрее оформлять заказы. Телефон уже берётся
                из аккаунта, остальные данные можно изменить позже в профиле.
              </p>
            </div>
            <div className="p-4 pt-0 flex flex-col gap-2">
              <button
                type="button"
                onClick={handleFill}
                disabled={saving}
                className="w-full h-11 rounded-md bg-primary text-white font-semibold hover:bg-primary-hover disabled:opacity-50 transition-colors"
              >
                Заполнить
              </button>
              <button
                type="button"
                onClick={handleLater}
                disabled={saving}
                className="w-full h-11 rounded-md border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 disabled:opacity-50 transition-colors"
              >
                Позже
              </button>
              <Link
                to="/profile"
                className="block text-center text-sm text-primary hover:underline py-2"
                onClick={handleLater}
              >
                Заполнить в профиле
              </Link>
            </div>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <h2 id="autofill-title" className="text-xl font-semibold text-gray-900">
              Контакты для оформления заказа
            </h2>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="email@example.com"
                className="w-full h-10 px-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-light"
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Адрес доставки
              </label>
              <input
                type="text"
                value={delivery_address}
                onChange={(e) => setDeliveryAddress(e.target.value)}
                placeholder="Адрес доставки"
                className="w-full h-10 px-3 rounded-md border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary-light"
              />
            </div>
            <div className="flex gap-2 pt-2">
              <button
                type="button"
                onClick={() => setStep('prompt')}
                className="h-10 px-4 rounded-md border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
              >
                Назад
              </button>
              <button
                type="submit"
                disabled={saving}
                className="flex-1 h-10 rounded-md bg-primary text-white font-semibold hover:bg-primary-hover disabled:opacity-50"
              >
                {saving ? 'Сохранение…' : 'Сохранить'}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
